import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppUiModule } from '../../ui/app-ui.module';
import { SharedModule } from '../../shared/shared.module';
import { TicketsRoutingModule } from './tickets-routing.module';
import { TicketViewComponent } from './ticket-view/ticket-view.component';
import { TicketViewPipeCommentsPart } from './ticket-view/ticket-view.pipe';
import { AddCommentComponent } from './ticket-view/components/add-comment/add-comment.component';
import { TicketStatusChangeComponent } from './ticket-view/components/ticket-status-change/ticket-status-change.component';
import { WorkShiftExpandedModule } from '../work-shift/work-shift-expanded.module';
import { CheckListsSharedModule } from '../check-lists-page/modules/shared/check-lists-shared.module';

@NgModule({
  declarations: [TicketViewComponent, TicketViewPipeCommentsPart, AddCommentComponent, TicketStatusChangeComponent],
  imports: [CommonModule, TicketsRoutingModule, AppUiModule, SharedModule, FormsModule, ReactiveFormsModule, WorkShiftExpandedModule, CheckListsSharedModule],
  exports: [TicketViewPipeCommentsPart],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TicketsModule {}
